import React from 'react';
import AnnunciLista from './AnnunciLista';

function AnnunciOperatoreSportelli() {
    return <AnnunciLista conContatto={true}/>
}

export default AnnunciOperatoreSportelli
